import FeatureSlider from './FeatureSlider';

export default FeatureSlider;